import { Storage } from 'aws-amplify';


export const AWS_REGION = "us-west-2";
export const TENANT_PHYSIOHUB = "physiohub";
export const TENANT_CAPACITY_TEST = "capacitytest";
export const TENANT_CAPACITY_PROD = "capacityprod";
export const TENANT_CLIENT1PREFIX = "client1prefix";

// Helper to check if tenant is a Capacity tenant
export const isCapacityTenant = (tenant: string) => {
    return tenant === TENANT_CAPACITY_TEST || tenant === TENANT_CAPACITY_PROD;
};


export const getSignedDownloadLink = async (key: string, tenant: string) => {
    const kmsAlias = `alias/${tenant}-ed-kms-key`;
    const config = {
        bucket: `${tenant}-ed-staging`,
        region: AWS_REGION,
        serverSideEncryption: 'aws:kms',
        SSEKMSKeyId: kmsAlias,
        contentType: 'text',
        download: false,
        cacheControl: 'no-cache',
        customPrefix: {
            public: ''
        },
    }

    try {
        return await Storage.get(key, config);
    } catch (e: any) {
        console.error("Failed to retrieve S3 file ", e);
    }
}

export const readFile = async (key: string, tenant: string) => {
    const kmsAlias = `alias/${tenant}-ed-kms-key`;
    const config = {
        bucket: `${tenant}-ed-staging`,
        region: AWS_REGION,
        serverSideEncryption: 'aws:kms',
        SSEKMSKeyId: kmsAlias,
        contentType: 'text',
        download: true,
        cacheControl: 'no-cache',
        customPrefix: {
            public: ''
        },
    }

    try {
        const result: any = await Storage.get(key, config);
        return result['Body'].text();
    } catch (e: any) {
        console.error("Failed to retrieve S3 file ", e);
    }
}

export const readBinaryFile = async (key: string, tenant: string, bucketSuffix?: string) => {
    const kmsAlias = `alias/${tenant}-ed-kms-key`;
    const config = {
        bucket: `${tenant}-${bucketSuffix || 'ed-staging'}`,
        region: AWS_REGION,
        serverSideEncryption: 'aws:kms',
        SSEKMSKeyId: kmsAlias,
        contentType: 'arraybuffer',
        download: true,
        cacheControl: 'no-cache',
        customPrefix: {
            public: ''
        },
    }
    const result: any = await Storage.get(key, config);
    return result['Body'].arrayBuffer();
}

/**
 * Gets a pre-signed URL for a file in S3 without downloading it
 * Similar to readBinaryFile but returns a URL instead of downloading
 */
export const getFileUrl = async (key: string, tenant: string, bucketSuffix?: string) => {
    const kmsAlias = `alias/${tenant}-ed-kms-key`;
    const config = {
        bucket: `${tenant}-${bucketSuffix || 'ed-staging'}`,
        region: AWS_REGION,
        serverSideEncryption: 'aws:kms',
        SSEKMSKeyId: kmsAlias,
        download: false, // This is the key difference - we don't want to download
        expires: 3600,   // URL expires in 1 hour
        cacheControl: 'no-cache',
        customPrefix: {
            public: ''
        },
    }
    
    try {
        // This will return a pre-signed URL with the same auth as your other requests
        const result = await Storage.get(key, config);
        console.log("Generated pre-signed URL for", key);
        return result; // This should be the pre-signed URL string
    } catch (e: any) {
        console.error("Failed to generate pre-signed URL for S3 file", e);
        throw e;
    }
}
